// extracted by mini-css-extract-plugin
module.exports = {"container":"CmsVimeo-module--container--2PBx9","video":"CmsVimeo-module--video--2ZMnD"};